import { QueryKeys } from "@/modules/core";
import { queryOptions } from "@tanstack/react-query";
import { AccountRelationship } from "../types";
import { callRPC } from "@/modules/core/hive-tx";

export function getRelationshipBetweenAccountsQueryOptions(
  reference: string | undefined,
  target: string | undefined
) {
  return queryOptions({
    queryKey: QueryKeys.accounts.relations(reference, target),
    enabled: !!reference && !!target,
    refetchOnMount: false,
    refetchInterval: 3_600_000,
    queryFn: async () => {
      const fallback: AccountRelationship = {
        follows: false,
        ignores: false,
        blacklists: false,
        follows_muted: false,
        follows_blacklists: false,
      };

      // `enabled` only gates the automatic useQuery run. fetchQuery and
      // prefetchQuery invoke queryFn regardless, so guard here as well rather
      // than sending a missing account name to the RPC and caching the result.
      if (!reference || !target) {
        return fallback;
      }

      const result = await callRPC("bridge.get_relationship_between_accounts", [reference, target]);
      return (result ?? fallback) as AccountRelationship;
    },
  });
}
